module.exports = __webpack_public_path__ + "static/media/Grupo05mg.09655ac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/Grupo05mg.png
// module id = 93
// module chunks = 0